<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">运营商信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px;">
        <el-form-item label="方案名称" prop="projectName">
          <div class="ml-50">{{ form.projectName }}</div>
        </el-form-item>
        <!-- <el-form-item label="承担方" prop="responsible">
          <div class="ml-50">{{ form.responsible=="0" ? '全平台直连' : form.responsible=="1" ? '加盟直连' : '互联互通' }}</div>
        </el-form-item> -->
        <el-form-item label="活动电站" prop="saveStation">
          <el-radio-group v-model="form.saveStation" disabled>
            <el-radio label="2">选择运营商</el-radio>
            <el-radio label="3">选择电站</el-radio>
            <!-- <el-radio label="2">互联互通</el-radio> -->
          </el-radio-group>

          <!-- <el-button v-show="!disabled" type="primary" plain @click="getDetail">确认</el-button> -->
        </el-form-item>
        <el-form-item prop="operator">
          <div class="border">
            <template v-if="form.saveStation == '2'">
              <el-tree
                ref="stationTree1"
                :data="stationData1"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                 :default-checked-keys="form.operator"
              />
            </template>
            <template v-if="form.saveStation == '3'">
              <el-tree
                ref="stationTree2"
                :data="stationData2"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="form.operator"
              />
            </template>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">方案配置</span>
      </div>
      <el-form ref="lastform" :model="lastform" :rules="lastrules" label-width="120px" style="width: 600px; margin-top: 20px;">
        <el-form-item label="活动时间" prop="date">
          <div class="ml-50">{{ lastform.discountStartDay }} 至 {{ lastform.discountEndDay }}</div>
        </el-form-item>
        <el-form-item label="活动周天" prop="checkList" style="width: 700px;">
          <div style="margin-left: 40px;"><el-tag v-for="(item, index) in lastform.checkList" :key="index" size="medium" style="margin-left: 10px;">{{ item }}</el-tag></div>
        </el-form-item>
        <el-form-item label="活动介绍" prop="recommend" style="width: 600px;">
          <div class="ml-50">{{ lastform.recommend }}</div>
        </el-form-item>
        <el-form-item label="电费优惠" prop="electricModel">
          <div style="display: flex;">
            <div class="ml-50">{{ lastform.pricingModel.elecDiscount == 'fixed'? '一口价' : '折扣价' }}</div>
            <span>{{ lastform.pricingModel.elecValue }}</span>
            <div>{{ lastform.priceText }}</div>
          </div>
        </el-form-item>
        <el-form-item label="服务费优惠" prop="serviceModel">
          <div style="display: flex;">
            <div class="ml-50">{{ lastform.pricingModel.serviceDiscount == 'fixed'? '一口价' : '折扣价' }}</div>
            <span>{{ lastform.pricingModel.serviceValue }}</span>
            <div>{{ lastform.serviceText }}</div>
          </div>
        </el-form-item>
          <el-form-item label="活动用户" prop="userType">
            <el-radio-group v-model="form.userType" disabled>
              <el-radio
                v-for="(item, index) in userTypeItem"
                :key="index"
                :label="item.id"
              >{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="form.userType === '2'" class="border">
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="form.mechanism"
                :check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="form.userType === '3'" class="border">
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="form.tag"
              />
            </div>
          </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { treeDisabled } from '@/utils/tool'
const token = window.localStorage.getItem('token')
// import times from "../plantManagement/data.json";
export default {
  name: 'Youhuifanganxiangqing',
  components: {},
  data() {
    return {
      stationData1:[],
      stationData2:[],
            treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      mechanismTreeData:[],
      tagTreeData:[],
           userTypeItem: [
        {
          label: '全部用户',
          id: '1'
        },
        {
          label: '选择企业',
          id: '2'
        },
        {
          label: '选择标签',
          id: '3'
        }
      ],
            filterMechanismText: '', // 企业过滤
      form: {
        projectName: '',
        responsible: 0,
        operator: '',
        date: [],
        saveStation:'2',
        checkList: [],
        discountSiteList: [],
        recommend: '',
        userType: '2', // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [] // 选择标签
      },
      operatorTree: [],
      rules: {},
      lastform: {
        pricingModel: {},
        priceText: '',
        serviceText: '',
        userID: []
      },
      rowdata: {},
      lastrules: {},
      discountSiteTree: [],
      userTree: [],
      id: {}
    }
  },
  computed: {
    headers() {
      return {
        token: token
      }
    }
  },
  beforeMount() {
    this.id = this.$route.query.data
  },
  mounted() {
    // 获取运营商树全部数据的函数
    this.getOperator()
    this.getUser()
    // 获取详情
    this.getDetail()
    // 获取活动用户树全部数据的函数
    // this.getUser()
    this.getMechanismTree()
    this.getTagTree()
  },
  methods: {
        getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: (resp) => {
          this.mechanismTreeData = treeDisabled(resp, true)
        }
      })
    },
        getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: (resp) => {
          this.tagTreeData = treeDisabled(resp, true)
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    },

    // 获取当前数据的详情
    getDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/business/discountterm/getUpdateById',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata = resp
          this.form.saveStation=resp.stationType
          this.form.projectName = resp.projectName // accountIds  用户    operator 运营商
          this.form.operator =resp.stationList&&resp.stationList.length>0?resp.stationList.split(','):[]
          this.form.responsible = resp.responsible
          this.lastform = resp
          this.lastform.pricingModel = JSON.parse(resp.pricingModel)
          if (resp.pricingModel.elecDiscount === 'fixed') {
            this.lastform.priceText = '元'
          } else {
            this.lastform.priceText = '%'
          }
          if (resp.pricingModel.serviceDiscount === 'fixed') {
            this.lastform.serviceText = '元'
          } else {
            this.lastform.serviceText = '%'
          }
          this.lastform.userID = resp.accountList || []

          const weekList = resp.discountWeek.split(',')
          for (let i = 0; i < weekList.length; i++) {
            if (weekList[i] === '1') {
              weekList[i] = '周日'
            } else if (weekList[i] === '2') {
              weekList[i] = '周一'
            } else if (weekList[i] === '3') {
              weekList[i] = '周二'
            } else if (weekList[i] === '4') {
              weekList[i] = '周三'
            } else if (weekList[i] === '5') {
              weekList[i] = '周四'
            } else if (weekList[i] === '6') {
              weekList[i] = '周五'
            } else if (weekList[i] === '7') {
              weekList[i] = '周六'
            }
          }
          // this.form.discountSiteList = resp.stationList || []
          this.lastform.checkList = weekList
          this.form.userType=resp.userType
            if(resp.userType==1){
                     this.form.mechanism = []
                     this.form.tag = []
          }
          else if(resp.userType==2){
               this.form.mechanism = resp.accountList&&resp.accountList.length>0 ? resp.accountList.split(',') : []
          }
          else{
           this.form.tag = resp.accountList&&resp.accountList.length>0 ? resp.accountList.split(',') : []
          }
          // this.$store.dispatch('form/handle', {
          //   url: '/business/discountterm/getStation',
          //   data: {
          //     orgIds: this.form.operator.join(',')
          //   },
          //   method: 'get',
          //   callback: resp => {
          //     this.discountSiteTree = treeDisabled(resp, true)
          //     this.$forceUpdate()
          //   }
          // })
        }
      })
    },
    // 获取活动用户树的全部数据
    getUser() {
     this.$store.dispatch("form/handle", {
        url: "/business/whitelist/getStationList",
        method: "get",
        callback: resp => {
          this.stationData2 =treeDisabled(resp,true);
        }
      });
    },
    // 获取运营商树的全部数据
    getOperator() {
      const data = {
        attr: this.form.responsible,
        orgTypes: "0,3",
        showOperatorName: true
      };
      this.$store.dispatch("form/handle", {
        url: "/business/discountterm/getResponsibleOrgTree",
        data: data,
        method: "get",
        callback: resp => {
          this.stationData1 =treeDisabled(resp,true);
        }
      });
    },
    // 无限滚动
    dropDownScrollFun(val) {
      const scroll = document.querySelector('.border')
      if (scroll.scrollHeight - (scroll.scrollTop + scroll.clientHeight) <= 2) {
        // 定位到距离底部2px的位置
        scroll.scrollTop = (scroll.scrollHeight - scroll.clientHeight - 2)
      }
    }
  }
}
</script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  /deep/.el-input{
    width: 15% !important;
  }
  .border {
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .ml-50{
    margin-left: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/views/discount/discountDetail.vue